<mat-form-field class="pr-1">
  <mat-label>{{ label() }}</mat-label>
  
  @if (isReadonly()) {
    <input matInput disabled="true" [value]="readonlyValue() ?? displayCompanyFn(formControl()?.value)" />
  } @else {
    <input
      type="text"
      matInput
      (keyup)="onSearchTermChange($event)"
      [matAutocomplete]="companyAuto"
      [formControl]="formControl()" />
    <mat-icon>search</mat-icon>
    <mat-icon>arrow_drop_down</mat-icon>
    <mat-autocomplete
      #companyAuto="matAutocomplete"
      [displayWith]="displayCompanyFn"
      (optionSelected)="onOptionSelected($event)"
      (opened)="onPanelOpened()"
      (closed)="onPanelClosed()">
      @for (company of companies(); track company) {
        <mat-option [value]="company">{{ company.name }}</mat-option>
      }
      @empty {
        <mat-option [value]="null">None</mat-option>
      }
    </mat-autocomplete>
  }
  @if (hasError) {
    <mat-error>{{ requiredErrorMessage() }}</mat-error>
  }
</mat-form-field>
